import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useRefCode = (param: RefCodeListReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [refCodeList, setRefCodeList] = useState<RefCodeListDto[] | any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading, refetch } = useQuery(
    [endpoints.refcode.list, {...param}],
    () => fetcher.refcode.getRefCodeList(param),
    {
      onSuccess: (res: RefCodeListResDto) => {
        switch (res.code) {
          case 200:
            setRefCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: refCodeInsert } = useMutation(
    [endpoints.refcode.add],
    fetcher.refcode.postRefCodeInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: refCodeUpdate } = useMutation(
    [endpoints.refcode.update],
    fetcher.refcode.postRefCodeUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: refCodeSort } = useMutation(
    [endpoints.refcode.sort],
    fetcher.refcode.postRefCodeSort,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )    

  return { isLoading, refCodeList, refetch, refCodeInsert, refCodeUpdate, refCodeSort };
};

export default useRefCode;
